<template>
    <div
        class="flex w-[full] flex-col lg:grid lg:grid-cols-24"
        :class="[
            spaceBetweenClasses,
            {
                'relative z-20': block.BackgroundElement?.length > 0,
            },
        ]"
        :style="spaceBetweenStyle"
    >
        <BlocksAnimation
            v-for="(item, index) in layoutBlocks"
            :key="item.canonicalUid"
            :animation-offset="index"
            :style="{
                'grid-column': `${item.grid.x + 1} / ${item.grid.x + item.grid.w + 1}`,
                'grid-row': `${item.grid.y + 1} / ${item.grid.y + item.grid.h + 1}`,
            }"
        >
            <LayoutWrapper
                :block="item"
                :parent-has-bg-element="block.BackgroundElement?.length"
                :class="`type-${item.__typename}-${item.typeIndex}`"
                is-layout
                :is-singleton="isSingleton(item)"
            />
        </BlocksAnimation>
    </div>
</template>

<script setup>
    import LayoutWrapper from '~/components/blocks/LayoutWrapper.vue'

    const props = defineProps({
        block: Object,
        blockParent: Object,
    })

    const spaceBetweenClasses = computed(() => {
        if (props.block?.ContainerWidth === 'standard') {
            // Prevents gap exceeding the max width of the standard container
            switch (props.block?.SpaceBetween) {
                case 'none':
                    return ''
                case 'sm':
                    return 'gap-2'
                case 'md':
                default:
                    return 'gap-4'
                case 'lg':
                    return 'gap-6'
                case 'xl':
                    return 'gap-8'
            }
        } else {
            switch (props.block?.SpaceBetween) {
                case 'none':
                    return ''
                case 'sm':
                    return 'gap-4'
                case 'md':
                default:
                    return 'gap-6'
                case 'lg':
                    return 'gap-8'
                case 'xl':
                    return 'gap-10'
            }
        }
    })

    const spaceBetweenStyle = computed(() => {
        if (props.block?.SpaceBetween !== 'none') {
            return
        }

        return '--radius-card-md: 0px;'
    })
    const typeCounts = {}

    // checks if this block is by itself on its own row
    const isSingleton = (block) => {
        return block.grid.x === 0 && block.grid.w === 24
    }

    const gridLayout = get(props.block, 'contentBuilderLayout.grid') ?? []

    const layoutBlocks = computed(() => {
        return map(get(props.block, 'contentBuilder'), (contentBlock, index) => {
            const layout = find(gridLayout, { index: index })

            // Skip the block if the layout is not found
            // There is currently a bug in the CMS that causes this to happen
            if (!layout) {
                return null
            }

            // typeCounts is used to keep track of the index of each type
            if (!typeCounts[contentBlock.__typename]) {
                typeCounts[contentBlock.__typename] = 0
            }

            if (['ds_EventsLayoutBlock_Entry', 'ds_NewsLayoutBlock_Entry'].includes(contentBlock.__typename)) {
                const hasSelectedArticle = contentBlock?.news_SelectArticle ?? contentBlock?.events_SelectArticle ?? []

                if (!hasSelectedArticle.length) {
                    typeCounts[contentBlock.__typename]++
                }
            } else {
                typeCounts[contentBlock.__typename]++
            }

            return {
                ...contentBlock,
                typeIndex: typeCounts[contentBlock.__typename],
                grid: {
                    x: layout.x,
                    y: layout.y,
                    w: layout.width,
                    h: layout.height,
                },
            }
        }).filter(Boolean)
    })
</script>

<style lang="scss" scoped></style>
